module.exports = __webpack_public_path__ + "img/glow-yellow-large.ae0dddc6.png";